<div class="cpc">
  <h3 class="cpc-title">
    {{
      isUpgrade ? 'Upgrade to ' + data.toPlanName + '?' : 'Downgrade to ' + data.toPlanName + '?'
    }}
  </h3>
  <p class="cpc-subtitle">
    @if (isUpgrade) {
      Your {{ data.toPlanName }} features will be available immediately after you confirm the
      upgrade.
    } @else {
      You'll stay on {{ data.fromPlanName }} {{ untilText }}. After that you'll move to
      {{ data.toPlanName }}.
    }
  </p>

  <div class="cpc-compare">
    <div class="cpc-box">
      <span class="cpc-box-label">From</span>
      <div class="cpc-box-name">{{ data.fromPlanName }}</div>
      <div class="cpc-box-price">
        <span class="cpc-price">{{ fromLabel.amount }}</span>
        @if (fromLabel.suffix) {
          <span class="cpc-price-suffix">{{ fromLabel.suffix }}</span>
        }
      </div>
    </div>
    <i class="bx bx-right-arrow-alt cpc-arrow"></i>
    <div class="cpc-box">
      <span class="cpc-box-label">To</span>
      <div class="cpc-box-name">{{ data.toPlanName }}</div>
      <div class="cpc-box-price">
        <span class="cpc-price">{{ toLabel.amount }}</span>
        @if (toLabel.suffix) {
          <span class="cpc-price-suffix">{{ toLabel.suffix }}</span>
        }
      </div>
    </div>
  </div>

  @if (isUpgrade) {
    <div class="cpc-info-banner">
      <span class="cpc-info-icon"><i class="bx bx-info-circle"></i></span>
      <div class="cpc-info-text">
        @if (data.prorated) {
          This change will take effect immediately. You'll be charged a prorated amount based on
          your remaining balance.
        } @else {
          This change will take effect immediately. This month's orders are billed at
          {{ data.toPlanName }}'s rates after the month ends.
        }
      </div>
    </div>
  } @else {
    <div class="cpc-warning-banner">
      <div class="cpc-warning-title">
        From {{ data.effectiveLabel || 'then' }}, these menus will be locked
      </div>
      <div class="cpc-warning-grid">
        @for (feature of data.lostFeatures; track feature) {
          <div class="cpc-warning-item"><span class="cpc-dot"></span>{{ feature }}</div>
        }
      </div>
    </div>
    <p class="cpc-effective-note">
      Takes effect {{ effectiveText }} · {{ toLabel.amount }}{{ toLabel.suffix }}
    </p>
  }

  <div class="cpc-actions">
    <button type="button" class="sub-btn sub-btn--outline" [disabled]="loading" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="sub-btn sub-btn--dark" [disabled]="loading" (click)="confirm()">
      {{ isUpgrade ? 'Confirm Upgrade' : 'Confirm Downgrade' }}
      @if (loading) {
        <i class="bx bx-loader-alt bx-spin"></i>
      }
    </button>
  </div>
</div>
